import React from 'react'
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Tooltip,
} from '@mui/material'
import imagefileicon from '../../../../assets/imgFile.svg'
import docxfileicon from '../../../../assets/Docfile.svg'
import SaveAltIcon from '@mui/icons-material/SaveAlt'
const FileCard = ({ fileName, fileSize, filePath, onClick }) => {
  const isDoc =
    fileName.toLowerCase().endsWith('.pdf') ||
    fileName.toLowerCase().endsWith('.txt') ||
    fileName.toLowerCase().endsWith('.docx')
  return (
    <Card
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        width: 260,
        p: 1,
        boxShadow: 1,
        borderRadius: 2,
      }}
    >
      <CardMedia
        component="img"
        image={isDoc ? imagefileicon : docxfileicon}
        sx={{
          width: 'fit-content',
          height: 'fit-content',
          borderRadius: 1,
          objectFit: 'cover',
          mr: 1.5,
        }}
      />
      <Box>
        <Tooltip title={fileName}>
          <Typography variant="body2" noWrap>
            {fileName.slice(0, 10)}{' '}
            {fileName.slice(fileName.lastIndexOf('.')) || 'Document.pdf'}
          </Typography>
        </Tooltip>
        {/* <Typography variant="caption" color="text.secondary">
          {`${fileSize} KB` || '0 KB'}
        </Typography> */}
      </Box>
      <SaveAltIcon onClick={onClick} color="disabled" />
    </Card>
  )
}

export default FileCard
